module.exports = __webpack_public_path__ + "media/images/ibu__icon__close-50f6cad18e67754bf7a4ab7435c47ab4.svg";